import '../CsvJsonInfoPages.scss';


function VehiclesOnRunOut() {

    const data = [
        { field: 1, description: 'CAP ID Number (Int)' },
        { field: 2, description: 'Run Out Date (Date, yyyy/mm/dd)' },
    ];


    return (
        <div className='csv-json-info-pages-container'>
            <h1>New Vehicle Data Enhanced - Vehicles On Run Out</h1>
            <p>his file contains vehicles which have recently been discontinued, but stock is still available. <br /><br />
                <b>File Naming Convention</b><br /><br />
                The Filename is dependant on the product being produced as follows.<br /><br />

                CAR_yyyy-mm-dd_CAPOnRunout.txt<br />
                LIGHTS_yyyy-mm-dd_CAPOnRunout.txt<br />
                HEAVIES_yyyy-mm-dd_ CAPOnRunout.txt<br />
                BIKES_yyyy-mm-dd_ CAPOnRunout.txt<br /><br />

                Note: yyyy-mm-dd represents the date of the product. E.g. 2003-07-01 would represent the date 1st July 2003.
            </p>
            <table>
                <thead>
                    <tr>
                        <th>Field</th>
                        <th>DATA</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((item, index) => (
                        <tr key={index}>
                            <td>{item.field}</td>
                            <td>{item.description}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

        </div>
    );
}

export default VehiclesOnRunOut;
